import Bugsnag from "@bugsnag/js";
import { makeAutoObservable } from "mobx";
import httpClient from "@/config/httpClient";
import { fetchMe } from "@/utils/auth/me";
import { endpoints } from "@/utils/common/requests/endpoints";
import { crewStore } from "../rootStore";
import construct from "../utils/construct";
import persist from "../utils/persist";

const { VITE_ENV } = import.meta.env;

// eslint-disable-next-line
let _rootStore;

/**
 * @typedef {Object} UserStoreProps
 * @property {string} token The authentication token for the user
 * @property {{ username?: string, email?: string, [key: string]: any } | null} data The user data fetched from the server
 * @property {"mementos" | "items" | null} lastApp The last application the user interacted with
 * @property {{
 * 	opt_defaultApp: "mementos" | "items" | "economos" | null,
 *  opt_thumbBurger: "hidden" | "left" | "right" | null,
 *  opt_groupShortcut: string | null
 * }} settings
 */

/** @type {UserStoreProps} */
const defaultProperties = {
	token: null,
	data: null,
	lastApp: null,
	settings: {
		opt_defaultApp: null,
		opt_thumbBurger: null,
		opt_groupShortcut: null,
	},
};

export default class UserStore {
	token = defaultProperties.token;
	data = defaultProperties.data;
	lastApp = defaultProperties.lastApp;
	settings = defaultProperties.settings;

	constructor(rootStore) {
		construct(this, defaultProperties);
		_rootStore = rootStore;

		makeAutoObservable(this);
		persist(this, "userStore");
	}

	/**
	 * @param {keyof typeof defaultProperties["settings"]} key
	 */
	getSetting(key) {
		return this.settings[key];
	}

	/**
	 * @param {keyof typeof defaultProperties["settings"]} key
	 * @returns
	 */
	setSetting(key, value) {
		// @ts-expect-error settings dynamic assignment
		this.settings[key] = value;
	}

	reset() {
		construct(this, defaultProperties);
	}

	async fetchMe() {
		const { success, me, status } = await fetchMe();

		if (!success) {
			return { error: status === 0 ? "server" : "auth" };
		}

		if (VITE_ENV === "pro") {
			Bugsnag.setUser(me?.id, me?.email, me?.username);
		}

		this.data = me;

		return { me };
	}

	async fetchSettings() {
		const { response, isError } = await httpClient.get(endpoints.settings.GET());

		if (isError) {
			return console.log("[UserStore.fetchSettings] error");
		}

		this.settings = response;
	}

	async init() {
		console.log("[agora] INIT: Iniciando...");

		if (!this.token) {
			console.log("[agora] INIT: no token");
			return { error: "auth" };
		}

		const [meResult] = await Promise.all([
			this.fetchMe(),
			this.fetchSettings(),
			crewStore.fetchMyCrews(true),
		]);

		if (meResult?.error) {
			console.log("[agora] INIT: error", meResult.error);
			return { error: meResult.error };
		}

		console.log("[agora] INIT: ok");
		return { ok: true };
	}
}
